import React from "react";
import { Link, useParams } from "react-router-dom";
import data from "../../data/projects.json";

const ProjectSingle = () => {
  const { slug } = useParams();
  const ClickHandler = () => window.scrollTo(0, 0);

  const project = data.projects.find((proj) => proj.slug === slug);

  if (!project) {
    return <div>Project not found</div>;
  }

  const imgRequire = (path) => require(`../../images/${path}`);

  // Define meta fields based on project type
  const getMetaFields = () => {
    if (!project.meta) return null;

    return Object.entries(project.meta).map(([key, val]) => (
      <li key={key}>
        {key}: <span>{val}</span>
      </li>
    ));
  };

  return (
    <section className="wpo-project-single-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <div className="wpo-project-single-wrap">
              {/* Main Content */}
              <div className="wpo-project-single-content">
                <img src={imgRequire(project.mainImage)} alt="" />
                <div className="wpo-project-single-content-des">
                  <div className="wpo-project-single-content-des-wrap">
                    <div className="wpo-project-single-content-des-left">
                      <h2>{project.title}</h2>
                      {project.description.map((p, i) => (
                        <p key={i}>{p}</p>
                      ))}
                    </div>

                    {/* Conditionally render meta section if it exists */}
                    {project.meta && (
                      <div className="wpo-project-single-content-des-right">
                        <ul>{getMetaFields()}</ul>
                      </div>
                    )}
                  </div>

                  {/* Sub Images - render only if they exist */}
                  {project.subImages && project.subImages.length > 0 && (
                    <div className="wpo-project-single-sub-img">
                      <ul>
                        {project.subImages.map((img, i) => (
                          <li key={i}>
                            <img src={imgRequire(img)} alt="" />
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>

              {/* Benefits Section - render only if benefits exist */}
              {project.benefits && project.benefits.length > 0 && (
                <div className="wpo-solutions-section">
                  <h2>Best Benefits of Prodct</h2>
                  <div className="row">
                    {project.benefits.map((b, i) => (
                      <div className="col-lg-4 col-md-6 col-12" key={i}>
                        <div className="wpo-solutions-item">
                          {b.icon && (
                            <div className="wpo-solutions-icon">
                              <img src={imgRequire(b.icon)} alt="" />
                            </div>
                          )}
                          <div className="wpo-solutions-text">
                            <h2>
                              <Link onClick={ClickHandler} to={b.link || "#"}>
                                {b.title}
                              </Link>
                            </h2>
                            {b.text && <p> {b.text}</p>}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Details Section - render only if details exist */}
              {project.details && project.details.length > 0 && (
                <div className="wpo-project-details">
                  {project.details.map((para, i) => (
                    <p key={i}> {para}</p>
                  ))}
                </div>
              )}

              {/* Tags & Share */}
              <div className="tag-share clearfix">
                {/* Tags - render only if tags exist */}
                {project.tags && project.tags.length > 0 && (
                  <div className="tag">
                    <ul>
                      {project.tags.map((t, i) => (
                        <li key={i}>
                          <Link onClick={ClickHandler} to="#">
                            {t}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Share buttons */}
                <div className="share">
                  <span>Share: </span>
                  <ul>
                    <li>
                      <Link onClick={ClickHandler} to="/project-single">
                        <i className="ti-facebook"></i>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/project-single">
                        <i className="ti-twitter-alt"></i>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/project-single">
                        <i className="ti-linkedin"></i>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/project-single">
                        <i className="ti-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectSingle;
